export {
    ThreeAlternatingImageText,
    type PatternThreeAlternatingImageTextProps
} from "./three-alternating-image-text";
export { ThreeAlternatingImageText as default } from "./three-alternating-image-text";
